import { useLocalSearchParams, useRouter } from "expo-router";
import { useEffect } from "react";
import { useInvitationToken } from "@/utils/useInvitationToken";
import { VStack } from "@/components/ui/vstack";
import { Spinner } from "@/components/ui/spinner";

export default function InvitationIndex() {
  const { token } = useLocalSearchParams<{ token: string }>();
  const router = useRouter();
  const [_, __, setStoredTokenAsync] = useInvitationToken();

  useEffect(() => {
    setStoredTokenAsync(token, false).then((newToken) => {
      if (newToken) {
        router.replace("/");
      }
    });
  }, []);

  return (
    <VStack className="gap-6">
      <Spinner size="large" />
    </VStack>
  );
}
